module.exports = __webpack_public_path__ + "img/smart-scan.00012da8.png";